<template>
  <v-dialog v-model="internalValue" :max-width="maxWidth" persistent>
    <v-card class="pa-4">
      <div class="dialog-header mb-4">
        <slot name="header">
          <h3 class="font-weight-bold mb-2">{{ title }}</h3>
        </slot>
        <slot name="subtitle">
          <p class="subtitle">{{ subtitle }}</p>
        </slot>
      </div>

      <v-card-text>
        <slot />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('cancel')" :disabled="loading" block>
          {{ cancelText }}
        </v-btn>
        <v-btn :color="confirmColor" :loading="loading" text dark @click="$emit('confirm')" block>
        {{ confirmText }}
        <template v-slot:loader>
            <span class="custom-loader"><v-icon dark>cached</v-icon></span>
        </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    value: { type: Boolean, required: true },
    title: { type: String, default: 'Edita Esdeveniment' },
    subtitle: { type: String, default: '' },
    cancelText: { type: String, default: 'Cancel·la' },
    confirmText: { type: String, default: 'Desa' },
    maxWidth: { type: String, default: '500px' },
    confirmColor: { type: String, default: 'orange darken-1' },
    backgroundColor: { type: String, default: '#f9efd5' },
    event: Object,
    matchTeams: Object,
    loading: { type: Boolean, default: true }
  },
  computed: {
    internalValue: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  }
}
</script>

<style>
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
